import { css } from "@emotion/react";

export const center = css`
  width: 100%;
  text-align: center;
`;
